import { ColumnDefinition } from '../../../../../../types/ReactTableTypes';

import { addVideoToIndexColumn, addVideoToGameDateColumn } from './baseColumnDefinitions';
import { coachColumnDefinitions } from './coachColumnDefinitions';
import { generalManagerColumnDefinitions } from './generalManagerColumnDefinitions';
import { goaltenderColumnDefinitions } from './goaltenderColumns/goaltenderColumnDefinitions';
import { skaterColumnDefinitions } from './skaterColumns/skaterColumnDefinitions';
import { teamColumnDefinitions } from './teamColumns/teamColumnDefinitions';

// Tries to get the columns from a dictionary of arrays with column listings. Else uses columns from data from server.
export const getColumnDataForPage = ({ pathname, search }, setVideoId) => {
    const page = pathname.slice(pathname.lastIndexOf('/') + 1);
    let columns: ColumnDefinition[] = [];

    // Add the columns listed in the templates
    if (pathname.includes('skater-records')) {
        columns = skaterColumnDefinitions[page];
    } else if (pathname.includes('goaltender-records')) {
        columns = goaltenderColumnDefinitions[page];
    } else if (pathname.includes('team-records')) {
        columns = teamColumnDefinitions[page];
    } else if (pathname.includes('general-manager-records')) {
        columns = generalManagerColumnDefinitions[page];
    } else if (pathname.includes('coach-records')) {
        columns = coachColumnDefinitions[page];
    } else {
        console.warn(`No columns for ${page}`);
    }

    // Dev safety purposes -- warns if the above definitions returns empty
    if (!columns) {
        columns = [];
        console.error(`The columns for ${page} returned undefined`);
    }

    // We will update the index/rank column and add in a video player (INDEX_COL, and MULTI_SORT_INDEX)
    // We will do this here so we don't have to pass setVideoId to like 400 pages
    if (columns && columns[0].id === 'index') {
        columns[0].Cell = addVideoToIndexColumn(setVideoId, columns[0].accessor);
    } else if (columns && columns[0].accessor === 'gameDate') {
        columns[0].Cell = addVideoToGameDateColumn(setVideoId);
    }

    if (search.toLowerCase().includes('devmode=true') && columns[0].accessor != 'id') {
        columns.unshift({
            accessor: 'id',
            Header: 'Id',
            width: 80,
        });
    }

    return columns;
};
